import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const PartsPerMillion: ConvertableUnit = {
  label: "ppm",
  toStandardUnit: ppm => ppm,
  toThisUnit: ppm => ppm
};

export const MilligramsPerLiter: ConvertableUnit = {
  label: "mg/L",
  toStandardUnit: mgl => mgl * 1.001142303,
  toThisUnit: mgl => mgl / 1.001142303
};

const unitList = [PartsPerMillion, MilligramsPerLiter];
export const ConcentrationUnits = {
  PartsPerMillion,
  MilligramsPerLiter,
  options: buildOptions(unitList)
};
